import * as types from "./emitir.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  tokenRecaptcha: ""
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.SET_TOKEN_RECAPTCHA:
      return state.merge({ tokenRecaptcha: payload });
    default:
      return state;
  }
};

store.registerDynamicModule("servicoEmpresa.crachaAmbulante.emitir", reduce);
